import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Grid, Button, Box, InputLabel, FormControl, Select, MenuItem } from '@mui/material';

const validationSchema = Yup.object({});

interface SampasAyarlariProps {
    sabit: any;
    onUpdate: (updatedValues: any) => Promise<void>;
}

const SampasAyarlari: React.FC<SampasAyarlariProps> = ({ sabit, onUpdate }) => {

    const handleSubmit = async (values: any) => {
        const updatedValues = {
            ...sabit,
            ilMi: values.ilMi,
        };
        await onUpdate(updatedValues);
    };

    return (
        <Formik
            enableReinitialize
            initialValues={{
                ilMi: sabit?.ilMi || '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
        >
            {({ values, handleChange, handleBlur, dirty }) => (
                <Form>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel id="ilMi-label">İl Mi? (Büyükşehir)</InputLabel>
                                <Select
                                    labelId="ilMi-label"
                                    id="ilMi"
                                    name="ilMi"
                                    value={values.ilMi ?? ''}
                                    label="İl Mi? (Büyükşehir)"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    sx={{ minHeight: 56 }}
                                >
                                    <MenuItem value="E">Evet (Rayiç Gizle)</MenuItem>
                                    <MenuItem value="H">Hayır (Rayiç Göster)</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Box textAlign={{ xs: 'center', md: 'right' }}>
                                <Button type="submit" variant="contained" disabled={!dirty}>
                                    Kaydet
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Form>
            )}
        </Formik>
    );
};

export default SampasAyarlari;
